<template>
    <div>
        <banner-generic :data="content.hero"></banner-generic>

        <section class="padding--lg">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <div>
                            <p>Sunt autem nusquam hoc epicurus in gravissimo bello animadversionis metu contineret, saluti prospexit. simo bello animadversionis metu continere sunt autem nusquam hoc epicurus in gravis.</p>

                            <sample-form
                                :colours="content.colourModal"
                                :brochures="content.brochureModal"
                                :selectedColours="content.selectedColours"
                            />

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <cta v-if="content.cta" :data="content.cta" />

    </div>
</template>

<script>
    import { BannerGeneric, SampleForm, Cta } from "../components";

    export default {
        name: "v-sample",
        components: {
            BannerGeneric,
            SampleForm,
            Cta,
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {

                // Dummy page data array
                // json has been validated and linted
                // ======

                "content":{
                    "hero":{
                        "title":"Request a sample or a brochure",
                        "content":"",
                        "background":"_resources/themes/colorsteel/dist/assets/images/develop/hero-generic.png",
                        "style":"double",
                    },
                    "colourModal": {
                        "title": "Colours",
                        "description": "The colours you see on screen are as close as possible to actual product colours. However, all screens will show colour slightly differently. We recommend ordering a colour sample before purchasing.",
                        "colourGroup": [
                            {
                                "title": "Matte Range",
                                "description": "",
                                "colours": [
                                    { "id": 0, "theme": "default", "size": "large", "state": "", "name": "Colour Name", "hex": "#ffffff", "tsr": "22%", "lrv": "6%" },
                                    { "id": 1, "theme": "default", "size": "large", "state": "", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                                ]
                            },
                            {
                                "title": "Standard Range",
                                "description": "",
                                "colours": [
                                    { "id": 0, "theme": "default", "size": "large", "state": "", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                                    { "id": 1, "theme": "default", "size": "large", "state": "", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                                    { "id": 2, "theme": "default", "size": "large", "state": "", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                                    { "id": 3, "theme": "default", "size": "large", "state": "", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                                ]
                            }
                        ]
                    },
                    "brochureModal": {
                        "title": "Brochures",
                        "description": "Select the items you would like to receive in the mail.",
                        "brochureGroup": [
                            {
                                "title": "",
                                "description": "",
                                "brochures": [
                                    {
                                        "id":0,
                                        "favorite": false,
                                        "title":"Image title",
                                        "description":"",
                                        "link":"",
                                        "image":"_resources/themes/colorsteel/dist/assets/images/develop/article-1.png",
                                        "pdf": "",
                                        "sample": false,
                                        "style":"",
                                        "colour": "",
                                        "category": "",
                                        "position":"right",
                                        "layout":"full",
                                    },
                                    {
                                        "id":1,
                                        "favorite": false,
                                        "title":"Image title",
                                        "description":"",
                                        "link":"",
                                        "image":"_resources/themes/colorsteel/dist/assets/images/develop/article-1.png",
                                        "pdf": "",
                                        "sample": false,
                                        "style":"",
                                        "colour": "",
                                        "category": "",
                                        "position":"right",
                                        "layout":"full",
                                    },
                                ]
                            }
                        ]
                    },
                    "selectedColours": [
                        { "id": 0, "theme": "default", "size": "large", "state": "selected", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                        { "id": 1, "theme": "default", "size": "large", "state": "selected", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                        { "id": 2, "theme": "default", "size": "large", "state": "selected", "name": "Colour Name", "hex": "#000000", "tsr": "22%", "lrv": "6%" },
                    ],
                }
            }
        },
        methods: {

        },
        created() {

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

</style>


